import React from "react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  InputProps,
} from "@chakra-ui/react";
import { useController, Control, FieldValues, Path } from "react-hook-form";
import { formatCEP } from "../../../utils/validation";

interface FormCEPInputProps<T extends FieldValues>
  extends Omit<InputProps, "name" | "value" | "onChange"> {
  name: Path<T>;
  label: string;
  control: Control<T, any, any>;
  isRequired?: boolean;
}

export function FormCEPInput<T extends FieldValues>({
  name,
  label,
  control,
  isRequired = false,
  ...inputProps
}: FormCEPInputProps<T>) {
  const {
    field: { value, onChange, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const formattedValue = formatCEP(inputValue);
    onChange(formattedValue);
  };

  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      <FormLabel>{label}</FormLabel>
      <Input
        {...field}
        {...inputProps}
        value={value || ""}
        onChange={handleChange}
        placeholder="00000-000"
        maxLength={9}
      />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </FormControl>
  );
}
